import { Component, Input } from '@angular/core';
import { AmplitudeService } from '@inyova/inyova-shared';

import { CustomerInvestmentData } from 'src/app/modules/shared/models/Strategy';

@Component({
  selector: 'app-strategy-portfolio-summary',
  templateUrl: './strategy-portfolio-summary.component.html',
  styleUrls: ['./strategy-portfolio-summary.component.scss'],
  standalone: false
})
export class StrategyPortfolioSummaryComponent {
  @Input() appLocation: string;
  @Input() investmentData: CustomerInvestmentData;
  @Input() step: number;
  @Input() language: string;

  constructor(private amplitudeService: AmplitudeService) {}

  getStockBondValue(type: 'stock' | 'bond'): number {
    const stock_split = this.step === 5 ? this.investmentData.live_stock_split : this.investmentData.stock_split;
    return (type === 'stock' ? stock_split : 1 - stock_split) * 100;
  }

  trackTooltip(name: string) {
    this.amplitudeService.trackEvent('Tooltip Info Consulted', {
      tooltip_name: name,
      screen: 'portfolio summary (web)',
      consultation_method: 'hover'
    });
  }
}
